import React from 'react';
import { Link } from 'react-router-dom';
import { Button } from '../components/ui/button';
import { Card, CardContent } from '../components/ui/card';
import SEO from '../components/SEO';
import Header from '../components/Header';
import Footer from '../components/Footer';
import Breadcrumb from '../components/Breadcrumb';
import { 
  FileText, 
  Calendar, 
  Clock, 
  ArrowRight, 
  Building2,
  Brain,
  Euro,
  Search,
  Shield,
  TrendingUp,
  BookOpen,
  Leaf,
  Receipt,
  Scale,
  AlertTriangle,
  Zap,
  Target,
  HardHat,
  Users
} from 'lucide-react';

const BLOG_ARTICLES = [
  // NOUVEAUX ARTICLES MAI 2026 - RSE Social / IA Générative / CADA Open Data
  {
    id: 'clauses-sociales-rse-marches-publics',
    slug: '/blog/clauses-sociales-rse-marches-publics',
    title: 'Clauses Sociales RSE Marchés Publics 2026 : Insertion, Handicap, Égalité',
    excerpt: 'Le pilier social de la RSE devient décisif. Insertion professionnelle, OETH 6 %, Index Égalité ≥ 75/100 : comment répondre concrètement aux exigences sociales.',
    category: 'RSE',
    readTime: '11 min',
    date: '2026-05-23',
    icon: Users,
    color: 'green',
    isNew: true,
    featured: true
  },
  {
    id: 'ia-generative-pme-marches-publics',
    slug: '/blog/ia-generative-pme-marches-publics',
    title: 'IA Générative et Marchés Publics : 7 Cas d\'Usage Concrets pour PME 2026',
    excerpt: 'ChatGPT, Claude, GPT-5.2 : comment les PME utilisent l\'IA générative pour synthétiser un DCE, rédiger un mémoire technique, estimer un prix. Gains et pièges à éviter.',
    category: 'Intelligence Artificielle',
    readTime: '13 min',
    date: '2026-05-23',
    icon: Brain,
    color: 'purple',
    isNew: true,
    featured: true
  },
  {
    id: 'cada-open-data-marches-publics',
    slug: '/blog/cada-open-data-marches-publics',
    title: 'CADA et Open Data des Marchés Publics 2026 : Vos Droits d\'Accès',
    excerpt: 'DECP, BOAMP, TED Europa, CADA : guide juridique complet pour accéder aux documents des marchés publics. Quels documents sont communicables, comment saisir la CADA.',
    category: 'Juridique',
    readTime: '12 min',
    date: '2026-05-23',
    icon: Scale,
    color: 'blue',
    isNew: true,
    featured: true
  },
  // NOUVEAUX ARTICLES RSE ET BATIMENT
  {
    id: 'bilan-carbone-marches-publics',
    slug: '/blog/bilan-carbone-marches-publics',
    title: 'Bilan Carbone et Marchés Publics : Guide et Accompagnement',
    excerpt: 'Comment réaliser son bilan carbone pour les marchés publics ? Méthodologie, outils et accompagnement personnalisé. Demandez un devis gratuit.',
    category: 'Environnement',
    readTime: '14 min',
    date: '2026-03-30',
    icon: Leaf,
    color: 'green',
    isNew: true,
    featured: true
  },
  {
    id: 'rse-marches-publics-guide',
    slug: '/blog/rse-marches-publics-guide',
    title: 'RSE et Marchés Publics : Guide Complet pour les Entreprises',
    excerpt: 'Comment intégrer la RSE dans vos réponses aux appels d\'offres ? Critères sociaux, environnementaux et de gouvernance. Guide pratique pour PME.',
    category: 'RSE',
    readTime: '12 min',
    date: '2026-03-30',
    icon: Users,
    color: 'green',
    isNew: true
  },
  {
    id: 'marches-publics-batiment-btp',
    slug: '/blog/marches-publics-batiment-btp',
    title: 'Marchés Publics BTP et Bâtiment : Guide Complet',
    excerpt: 'Comment répondre aux appels d\'offres de travaux publics ? Qualifications, garanties, mémoire technique BTP. Guide pour entreprises du bâtiment.',
    category: 'BTP',
    readTime: '15 min',
    date: '2026-03-30',
    icon: HardHat,
    color: 'orange',
    isNew: true
  },
  // ARTICLES SEO STRATÉGIQUES - Guides pratiques
  {
    id: 'comment-trouver-appels-offres',
    slug: '/blog/comment-trouver-appels-offres',
    title: 'Comment Trouver des Appels d\'Offres pour son Entreprise',
    excerpt: 'Découvrez où et comment trouver des appels d\'offres publics adaptés à votre entreprise. Sources, méthodes de veille et conseils pratiques pour PME.',
    category: 'Guide SEO',
    readTime: '10 min',
    date: '2026-03-12',
    icon: Search,
    color: 'violet',
    isNew: true
  },
  {
    id: 'comment-lire-dce-rapidement',
    slug: '/blog/comment-lire-dce-rapidement',
    title: 'Comment Lire un DCE Rapidement | Guide Pratique',
    excerpt: 'Apprenez à lire et comprendre un DCE (Dossier de Consultation des Entreprises) rapidement. Structure, documents clés, méthode de lecture efficace.',
    category: 'Guide SEO',
    readTime: '12 min',
    date: '2026-03-11',
    icon: FileText,
    color: 'blue',
    isNew: true
  },
  {
    id: 'comment-analyser-dce',
    slug: '/blog/comment-analyser-dce',
    title: 'Comment Analyser un DCE | Méthode Complète',
    excerpt: 'Guide complet pour analyser un DCE efficacement. Critères d\'attribution, points de vigilance, erreurs à éviter. Méthode d\'expert pour les marchés publics.',
    category: 'Guide SEO',
    readTime: '15 min',
    date: '2026-03-10',
    icon: Brain,
    color: 'purple',
    isNew: true
  },
  {
    id: 'comment-repondre-appel-offres',
    slug: '/blog/comment-repondre-appel-offres',
    title: 'Comment Répondre à un Appel d\'Offres | Guide Étape par Étape',
    excerpt: 'Guide complet pour répondre à un appel d\'offres public. Les étapes, les documents obligatoires, les erreurs à éviter. Conseils d\'experts pour PME.',
    category: 'Guide SEO',
    readTime: '14 min',
    date: '2026-03-09',
    icon: Shield,
    color: 'green',
    isNew: true
  },
  {
    id: 'comment-rediger-memoire-technique',
    slug: '/blog/comment-rediger-memoire-technique',
    title: 'Comment Rédiger un Mémoire Technique | Guide Complet',
    excerpt: 'Guide complet pour rédiger un mémoire technique gagnant. Structure, contenu, erreurs à éviter. Maximisez vos chances de remporter des marchés publics.',
    category: 'Guide SEO',
    readTime: '15 min',
    date: '2026-03-12',
    icon: FileText,
    color: 'emerald',
    isNew: true
  },
  {
    id: 'rc-vs-cctp-vs-ccap',
    slug: '/blog/rc-vs-cctp-vs-ccap',
    title: 'RC vs CCTP vs CCAP : Comprendre les Pièces du DCE',
    excerpt: 'Différences entre RC, CCTP et CCAP dans un DCE. Règlement de consultation, cahier des clauses techniques et administratives. Guide complet pour les marchés publics.',
    category: 'Guide SEO',
    readTime: '12 min',
    date: '2026-03-12',
    icon: FileText,
    color: 'violet',
    isNew: true
  },
  {
    id: 'criteres-attribution-marches-publics',
    slug: '/blog/criteres-attribution-marches-publics',
    title: 'Critères d\'Attribution des Marchés Publics | Guide Expert',
    excerpt: 'Comprendre les critères d\'attribution des marchés publics : prix, valeur technique, délai, environnement. Comment sont notées les offres ? Guide pour optimiser vos réponses.',
    category: 'Guide SEO',
    readTime: '15 min',
    date: '2026-03-12',
    icon: Target,
    color: 'orange',
    isNew: true
  },
  {
    id: 'mapa-definition-fonctionnement',
    slug: '/blog/mapa-definition-fonctionnement',
    title: 'MAPA : Définition et Fonctionnement | Guide Complet',
    excerpt: 'Qu\'est-ce qu\'un MAPA (Marché à Procédure Adaptée) ? Seuils 2026, fonctionnement, avantages. Guide complet pour comprendre et répondre aux MAPA.',
    category: 'Guide SEO',
    readTime: '10 min',
    date: '2026-03-12',
    icon: Zap,
    color: 'purple',
    isNew: true
  },
  // NOUVEAUX ARTICLES 2026 - Tendances
  {
    id: 'critere-environnemental-2026',
    slug: '/blog/critere-environnemental-2026',
    title: 'Critère Environnemental Obligatoire : Ce Qui Change au 22 Août 2026',
    excerpt: 'La loi Climat & Résilience impose un critère écologique dans TOUS les marchés publics. Décryptage complet des nouvelles obligations et comment s\'y préparer.',
    category: 'Réglementation',
    readTime: '10 min',
    date: '2026-02-16',
    icon: Leaf,
    color: 'green',
    isNew: true
  },
  {
    id: 'nouveaux-seuils-2026',
    slug: '/blog/nouveaux-seuils-2026',
    title: 'Nouveaux Seuils Marchés Publics 2026 : 60k€ et 100k€ Décryptés',
    excerpt: 'Décrets du 29 décembre 2025 : seuil de dispense à 60k€ pour les services, 100k€ pérennisé pour les travaux. Impact sur votre stratégie de réponse.',
    category: 'Réglementation',
    readTime: '8 min',
    date: '2026-02-15',
    icon: Euro,
    color: 'blue',
    isNew: true
  },
  {
    id: 'ia-commande-publique-2026',
    slug: '/blog/ia-commande-publique-2026',
    title: 'L\'IA dans la Commande Publique : Feuille de Route DAE 2026-2027',
    excerpt: 'Analyse automatique des offres, détection des OAB, aide à la rédaction des DCE : comment l\'État déploie l\'intelligence artificielle dans les achats publics.',
    category: 'Innovation',
    readTime: '12 min',
    date: '2026-02-14',
    icon: Brain,
    color: 'purple',
    isNew: true
  },
  {
    id: 'facturation-electronique-2026',
    slug: '/blog/facturation-electronique-2026',
    title: 'Facturation Électronique : Obligations Septembre 2026 pour les Marchés Publics',
    excerpt: 'Calendrier, impacts et mise en conformité : tout ce que les titulaires de marchés publics doivent savoir sur la e-facturation obligatoire.',
    category: 'Conformité',
    readTime: '9 min',
    date: '2026-02-13',
    icon: Receipt,
    color: 'amber',
    isNew: true
  },
  {
    id: 'pme-simplification-2026',
    slug: '/blog/pme-simplification-2026',
    title: 'PME et Simplification 2026 : Nouvelles Opportunités des Marchés Publics',
    excerpt: 'Seuils relevés, allotissement renforcé, plafond CA réduit : comment les réformes 2026 favorisent l\'accès des PME à la commande publique.',
    category: 'Stratégie',
    readTime: '11 min',
    date: '2026-02-12',
    icon: TrendingUp,
    color: 'teal',
    isNew: true
  },
  {
    id: 'defaillances-securisation-2026',
    slug: '/blog/defaillances-securisation-2026',
    title: 'Défaillances d\'Attributaires : Sécuriser Vos Marchés en 2026',
    excerpt: 'Nouveau mécanisme du 2ème candidat, détection des offres anormalement basses, stratégies de sécurisation juridique face aux risques économiques.',
    category: 'Juridique',
    readTime: '10 min',
    date: '2026-02-11',
    icon: AlertTriangle,
    color: 'red',
    isNew: true
  },
  // ARTICLES EXISTANTS
  {
    id: 'guide-dce',
    slug: '/blog/guide-dce',
    title: 'Guide Complet du DCE : Dossier de Consultation des Entreprises',
    excerpt: 'Tout comprendre sur le DCE : composition, analyse, pièges à éviter. Le guide indispensable pour bien répondre aux appels d\'offres.',
    category: 'Guide',
    readTime: '12 min',
    date: '2026-02-01',
    icon: FileText,
    color: 'violet'
  },
  {
    id: 'sources-marches-publics',
    slug: '/blog/sources-marches-publics',
    title: 'Les 10 Meilleures Sources pour Trouver des Marchés Publics en 2026',
    excerpt: 'BOAMP, DECP, TED Europa, SNCF, ADP... Découvrez toutes les plateformes pour ne manquer aucun appel d\'offres.',
    category: 'Ressources',
    readTime: '8 min',
    date: '2026-01-28',
    icon: Search,
    color: 'blue'
  },
  {
    id: 'seuils-marches-publics-2026',
    slug: '/blog/seuils-marches-publics-2026',
    title: 'Seuils des Marchés Publics 2026 : Le Guide Actualisé',
    excerpt: 'Tous les seuils en vigueur pour 2026 : MAPA, appels d\'offres, procédures formalisées. Mis à jour avec les dernières réglementations.',
    category: 'Réglementation',
    readTime: '6 min',
    date: '2026-01-25',
    icon: Euro,
    color: 'green'
  },
  {
    id: 'ia-marches-publics',
    slug: '/blog/ia-marches-publics',
    title: 'Comment l\'IA Révolutionne la Veille des Marchés Publics',
    excerpt: 'Intelligence artificielle et appels d\'offres : gain de temps, matching intelligent, analyse automatique. Le futur est là.',
    category: 'Innovation',
    readTime: '10 min',
    date: '2026-01-20',
    icon: Brain,
    color: 'purple'
  },
  {
    id: 'repondre-appel-offre',
    slug: '/blog/repondre-appel-offre',
    title: 'Comment Répondre à un Appel d\'Offres : Guide Étape par Étape',
    excerpt: 'De l\'analyse du DCE à la soumission de l\'offre : toutes les étapes pour maximiser vos chances de remporter le marché.',
    category: 'Guide',
    readTime: '15 min',
    date: '2026-01-15',
    icon: Shield,
    color: 'amber'
  },
  {
    id: 'pme-marches-publics',
    slug: '/blog/pme-marches-publics',
    title: 'PME et Marchés Publics : Comment Gagner Face aux Grandes Entreprises',
    excerpt: 'Stratégies et astuces pour les PME : allotissement, sous-traitance, critères RSE. Transformez votre taille en avantage.',
    category: 'Stratégie',
    readTime: '9 min',
    date: '2026-01-10',
    icon: TrendingUp,
    color: 'teal'
  }
];

const colorClasses = {
  violet: 'bg-violet-100 text-violet-700',
  blue: 'bg-blue-100 text-blue-700',
  green: 'bg-green-100 text-green-700',
  purple: 'bg-purple-100 text-purple-700',
  amber: 'bg-amber-100 text-amber-700',
  teal: 'bg-teal-100 text-teal-700',
  red: 'bg-red-100 text-red-700'
};

export default function BlogPage() {
  return (
    <>
      <SEO 
        title="Blog - Actualités et Guides Marchés Publics"
        description="Guides, actualités et conseils d'experts pour remporter vos appels d'offres publics. Optimisez votre veille et vos réponses avec nos ressources gratuites."
        path="/blog"
      />
      <div className="min-h-screen bg-white">
        <Header />
        
        {/* Breadcrumb */}
        <Breadcrumb 
          items={[
            { label: 'Blog' }
          ]} 
        />

      {/* Hero */}
      <section className="bg-gradient-to-b from-violet-50 to-white py-16">
        <div className="container mx-auto px-4 text-center">
          <div className="inline-flex items-center gap-2 px-4 py-2 bg-violet-100 text-violet-700 rounded-full text-sm font-medium mb-6">
            <BookOpen className="w-4 h-4" />
            Blog & Ressources
          </div>
          <h1 className="text-4xl md:text-5xl font-bold text-slate-900 mb-6">
            Tout Savoir sur les Marchés Publics
          </h1>
          <p className="text-xl text-slate-600 max-w-2xl mx-auto">
            Guides, actualités et conseils d'experts pour remporter vos appels d'offres. 
            Optimisez votre veille et vos réponses grâce à nos ressources gratuites.
          </p>
        </div>
      </section>

      {/* Articles Grid */}
      <section className="py-16">
        <div className="container mx-auto px-4">
          <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
            {BLOG_ARTICLES.map((article) => {
              const IconComponent = article.icon;
              return (
                <Link key={article.id} to={article.slug}>
                  <Card className="h-full hover:shadow-lg transition-shadow cursor-pointer group">
                    <CardContent className="p-6">
                      <div className="flex items-center justify-between mb-4">
                        <div className="flex items-center gap-2">
                          <span className={`px-3 py-1 rounded-full text-xs font-medium ${colorClasses[article.color]}`}>
                            {article.category}
                          </span>
                          {article.isNew && (
                            <span className="px-2 py-1 rounded-full text-xs font-bold bg-gradient-to-r from-violet-600 to-indigo-600 text-white">
                              NOUVEAU
                            </span>
                          )}
                        </div>
                        <div className={`w-10 h-10 rounded-lg ${colorClasses[article.color]} flex items-center justify-center`}>
                          <IconComponent className="w-5 h-5" />
                        </div>
                      </div>
                      
                      <h2 className="text-xl font-bold text-slate-900 mb-3 group-hover:text-violet-700 transition-colors">
                        {article.title}
                      </h2>
                      
                      <p className="text-slate-600 mb-4 line-clamp-3">
                        {article.excerpt}
                      </p>
                      
                      <div className="flex items-center justify-between text-sm text-slate-500">
                        <div className="flex items-center gap-4">
                          <span className="flex items-center gap-1">
                            <Calendar className="w-4 h-4" />
                            {new Date(article.date).toLocaleDateString('fr-FR', { day: 'numeric', month: 'short' })}
                          </span>
                          <span className="flex items-center gap-1">
                            <Clock className="w-4 h-4" />
                            {article.readTime}
                          </span>
                        </div>
                        <ArrowRight className="w-5 h-5 text-violet-600 group-hover:translate-x-1 transition-transform" />
                      </div>
                    </CardContent>
                  </Card>
                </Link>
              );
            })}
          </div>
        </div>
      </section>

      {/* Newsletter CTA */}
      <section className="bg-gradient-to-r from-violet-900 via-indigo-900 to-slate-900 py-16">
        <div className="container mx-auto px-4 text-center">
          <h2 className="text-3xl font-bold text-white mb-4">
            Ne manquez aucun article
          </h2>
          <p className="text-slate-300 mb-8 max-w-xl mx-auto">
            Recevez nos derniers guides et actualités sur les marchés publics directement dans votre boîte mail.
          </p>
          <div className="flex flex-col sm:flex-row gap-4 justify-center max-w-md mx-auto">
            <input 
              type="email" 
              placeholder="Votre email professionnel"
              className="flex-1 px-4 py-3 rounded-lg text-slate-900"
            />
            <Button className="bg-white text-violet-900 hover:bg-slate-100 px-6">
              S'abonner
            </Button>
          </div>
        </div>
      </section>

      <Footer />
    </div>
    </>
  );
}
